<template>
    <div class="container-fluid">
        <div class="page-title">
            <h4 v-if="!mobile">Plaques</h4>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-block">
                        <div class="table-overflow">
                            <b-form-input
                                v-model="filter"
                                type="search"
                                placeholder="Saisissez votre recherche"
                            ></b-form-input>

                            <b-table    :fields="fields" 
                                        :items="items" 
                                        :filter="filter" 
                                        @filtered="onFiltered"
                                        class='BTable' sticky-header striped no-border-collapse>
                                
                                <template #cell(Outil_associe)="data">
                                    <div v-if="data.item.Outil_associe!='-'" class="btn-group " role="group">
                                        <p class="btn btn-sm btn-outline-light active"  @click="agenda(data.item.Outil_associe)">{{ data.item.Outil_associe.name}} <br>{{data.item.Outil_associe_depuis}} </p>
                                                
                                    </div>
                                    <div v-else >
                                        <button type="button" class="btn btn-sm btn-primary m-auto" v-on:click="assign_modal(data.item.plate)">Affecter</button>
                                    </div>
                                </template>
                             
                                <template #cell(Numero_tel)="data">
                                    <a v-bind:href="'sms:'+ data.item.Numero_tel + '?&body=' + data.item.Code_plaque">{{ data.item.Numero_tel }}</a>
                                </template>
                                <!--<a v-bind:href="'sms:'+ data.item.system.plate.tel + '?&body=K' + data.item.system.plate.code">{{ data.item.system.plate.tel }}</a>-->

                                <template #cell(Derniere_mise_a_jour)="data">
                                
                                    {{data.item.Derniere_mise_a_jour}}
                                    
                                </template>

                            </b-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

<!-------------------------------------------------------------------------------->
        <b-modal ref="assign_modal" hide-footer centered title="Affecter votre plaque à un outil">
            <div class="d-block text-center">
                <form @submit.stop.prevent="assign_submit">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Plaque : </label><br>
                                <label>Sélectionnez le nouvel outil à affecter à cette plaque</label>
                                <select class="custom-select" v-model="selected_system" required>
                                    <option  disabled v-bind:value="null" selected>Choisissez un outil</option> 
                                    <option v-for="system in free_systems" v-bind:value="system" v-bind:key="system.id">
                                          {{system.name}} ({{system.code}})
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div> 
                    
                    <div class="text-right mrg-top-5">
                        <button type="button" v-on:click="assign_cancel" class="btn btn-default">Annuler</button>
                        <button type="submit" 
                            class="btn btn-sm btn-primary"   
                            v-bind:disabled='(selected_system == "")'>Affecter</button>
                            <div class="alert alert-danger" role="alert" v-if="error">
                                Une erreur est surevenue lors de l'assignation ! Veuillez contacter KEMTAG
                                <i class="ti-close float-right mt-1" @click="error = false"></i>
                            </div> 
                    </div>
                </form>
            </div>
        </b-modal>
<!------------------------------------------------------------------------------>        
    </div>
</template>

<script>
    import api from "../../config/_api";
    import { mapGetters } from 'vuex';
   

    export default {
        name: "Index",
        components:{
            
        },
        
        data () {
            return {
                selected_plate : false,
                selected_system: null,
                error: false,
                system :null,
                free_systems : [1],
                mirror_system :{
                    name: "",
                    code: "",
                    id: 1,
                    display_unit_id: 1,
                    display_unit:{
                        factor: 1,
                        tyre_size : 0,
                        working_width :0 
                    },
                },
                window: {
                    width: 0,
                    height: 0
                },
                mobile: false,
                tdClass : "text-center align-middle",
                thClass : "text-center",
                
                rows: 1,
                filter: null,
            }
        },
        computed: {
            ...mapGetters({ 
                structure : 'structure/structure',
                plates: 'plates/plates',
                systems: 'systems/systems',
            }),

            fields(){
                var fields=[];

                if(this.mobile){
                    fields=[
                        {key :'Code_plaque', sortable: true,thClass: this.thClass,tdClass:  this.tdClass } ,    
                        {key :'Type_plaque' ,sortable: true,thClass: this.thClass,tdClass: this.tdClass  } ,
                        {key :'Numero_tel' ,sortable: true,thClass: this.thClass,tdClass: this.tdClass  } ,
                        {key :'Outil_associe', sortable: true,thClass: this.thClass,tdClass:  this.tdClass } ,
                        //{key :'Derniere_mise_a_jour' ,label :'Dernière mise à jour' ,sortable: true,thClass: this.thClass,tdClass:this.tdClass  } ,   
                    ];
                }
                else {
                    fields=[
                        {key :'Code_plaque', sortable: true,thClass: this.thClass,tdClass: this.tdClass  } ,
                        {key :'Type_plaque' ,sortable: true,thClass: this.thClass,tdClass: this.tdClass  } ,
                        {key :'Numero_tel' ,sortable: true,thClass: this.thClass,tdClass: this.tdClass } ,
                        {key :'Outil_associe', sortable: true,thClass: this.thClass,tdClass:  this.tdClass } ,
                        //{key :'Derniere_mise_a_jour' ,label :'Dernière mise à jour' ,sortable: true,thClass: this.thClass,tdClass:this.tdClass  } ,
                    ];
                }
                return fields;
            },
            items(){
                var items=[];
                        
                var type="" ;
                var system="";
                var Outil_associe_depuis="";
                //var Derniere_mise_a_jour="";
                for (var plate of this.plates){
                    if(plate.virtual_sensor_id != null){
                        type="Plaque Compteur";
                        
                        //Derniere_mise_a_jour = this.timeSinceDate(plate.sensor.SDate_on_update);
                    }
                    else if(plate.virtual_sensor_id == null){
                        type="Plaque Outil";
                        //Derniere_mise_a_jour = null;
                    }
                   
                    if(!plate.system){
                        system='-';
                        Outil_associe_depuis='';
                    }
                    
                    else {
                        system = plate.system;
                        Outil_associe_depuis= "depuis le "+this.getDate(plate.commissionning_date);
                    }

                    items.push({
                        plate : plate,
                        Code_plaque : 'K'+plate.code,
                        Numero_tel : plate.tel,
                        Numero_tel_href: 'tel:' + plate.tel, 
                        Type_plaque : type,  
                        //Derniere_mise_a_jour : Derniere_mise_a_jour,
                        Outil_associe :system,
                        Outil_associe_depuis :Outil_associe_depuis, 
                    });
                    type="";
                    system="";
                    Outil_associe_depuis="";
                }

                return items;
            },  

        },
        created() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
            
        },
        mounted() {
            this.$store.dispatch('plates/getPlates');
            this.$store.dispatch('systems/getSystems');
            this.rows = this.plates.length;
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },

        methods: {
            handleResize() {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;
                this.mobile=(this.window.width<1080)? true : false ;
            },
            agenda(system){
            // Rediriger vers agenda de l'outil
            this.$router.push({ path: `/calendar/${system.id}` });
            },

            formatDate: function(date){
                var d = new Date(date),
                    month = '' + (d.getMonth() + 1),
                    day = '' + d.getDate(),
                    year = '' + d.getFullYear(),
                    hour = '' + d.getHours(),
                    minute ='' + d.getMinutes();
                //console.log("Date_to_format "+d)
                if (month.length < 2) 
                    month = '0' + month;
                if (day.length < 2) 
                    day = '0' + day;
                if (hour.length < 2) 
                    hour = '0' + hour;
                if (minute.length < 2) 
                    minute = '0' + minute;

                return [year, month, day].join('-') + " à " + [hour, minute].join(':');
            },

            timeSinceDate: function(lastUp){

                let date= new Date();
                let nowDate = Date.parse(date);

                var lastDate = Date.parse(lastUp) - date.getTimezoneOffset()*60*1000;//On part déjà d'une date UTC auquel on réapplique les timezone offset
                
                //console.log("NowDate: "+ date + "\t" + nowDate);
               //console.log("LastUp: "+ lastUp + "\t" + lastDate);

                var diff = nowDate - lastDate;
                //console.log(diff);
                if(diff > 0){
                    var diffDate = new Date(diff);
                    diffDate = new Date(diff+diffDate.getTimezoneOffset()*60*1000); //Pour corriger le passage d'utc à heure locale
                    var lastUpdate = "";
                    //console.log(diffDate)

                    if((diffDate.getFullYear() > 1970) || (diffDate.getMonth()>0) || (diffDate.getDate()>1)){

                        if(diffDate.getFullYear() > 1970){
                            lastUpdate = lastUpdate + (diffDate.getFullYear()-1970) + " an(s) ";
                        }
                        if(diffDate.getMonth()>0){
                            lastUpdate = lastUpdate + diffDate.getMonth() + " mois ";
                        }
                        if(diffDate.getDate()>0){
                            if(diffDate.getDate() == 1){
                                lastUpdate = lastUpdate + diffDate.getDate() + " jour ";
                            }
                            else{
                                lastUpdate = lastUpdate + diffDate.getDate() + " jours ";
                            }
                        }
                        return lastUpdate + " (" + this.formatDate(lastDate).substring(0,10) +")"
                    }
                    else if((diffDate.getHours()>0) || (diffDate.getMinutes()>0)){
                        if(diffDate.getHours()>0){
                            if(diffDate.getHours() == 1){
                                lastUpdate = lastUpdate + diffDate.getHours() + " heure ";
                            }
                            else{
                                lastUpdate = lastUpdate + diffDate.getHours() + " heures ";
                            }
                        }
                        if(diffDate.getMinutes()>0){
                            if(diffDate.getMinutes() == 1){
                                lastUpdate = lastUpdate + diffDate.getMinutes() + " minute";
                            }
                            else{
                                lastUpdate = lastUpdate + diffDate.getMinutes() + " minutes";
                            }
                        }
                        return lastUpdate + " (" + this.formatDate(lastDate) +")"
                    }
                }
                else if(lastUp == null){
                    return "Information non disponible"
                }
            },
           
            getDate(date){
                var d = new Date(date);
                var day = d.getDate(); 
                var m = d.getMonth()+1;
                var y = d.getFullYear();
                var fulldate=y+"-";
                if(m<10) fulldate+="0";
                fulldate+=m+"-";
                if(day<10) fulldate+="0";
                fulldate+=day;
                return fulldate;
            },

            assign_modal(plate) {
                this.selected_system = null;
                this.selected_plate = plate;
              //  console.log(this.free_systems);
              //  console.log(this.systems);
                if(plate.virtual_sensor_id!=null){

                    const systems = this.$store.getters['systems/systems'];
                    this.free_systems = systems.filter(system => system.sensor == null);
                    
                }
                //si on a une plaque outil sans sensor
                else if (plate.virtual_sensor_id==null){
                    //on affiche tous les systems non affecté à des plaques
                    const systems = this.$store.getters['systems/systems'];
                    const plates = this.$store.getters['plates/plates'];
                    //const systemIds = systems.map(system => system.id);
                    const plateSystemIds = plates.map(plate => plate.system_id);
                    this.free_systems = systems.filter(system => !plateSystemIds.includes(system.id));
                    /*console.log('Systems:', systems);
                    console.log('Plates:', plates);
                    console.log('System IDs:', systemIds);
                    console.log('Plate System IDs:', plateSystemIds);
                    console.log('Systems not in Plates:', this.free_systems);*/    
                }
                this.$refs.assign_modal.show()     
            },
            assign_cancel() {
                this.free_systems = [];
                this.$refs.assign_modal.hide()
            },
            assign_submit() {
                let url = api.url + 'plates/'+ this.selected_plate.id + '/assign/' + this.selected_system.id + '?structure_id=' + this.$store.getters.structure_id;
                this.axios({url: url, method: 'POST' })
                    .then(resp => {
                        if(resp.status <400){
                            this.$store.dispatch('plates/getPlates');
                            this.$refs.assign_modal.hide();
                            this.$router.push("/plates/index").catch(()=>{});
                        }                      
                    })
                    .catch(err => {
                        console.log(err);
                        this.error = true; 
                    });                
                this.free_systems = [];
            },
            onFiltered(filteredItems) {
                this.rows = filteredItems.length
            },
        }

    }
</script>

<style>

.asc:after{
    content: "\25B2"
}

.desc:after{
    content: "\25BC"
}
.BTable{
    max-height: 700px;
}

</style>